<template>
  <div class="md-layout">
    <!-- 表格 -->
    <div class="md-layout-item md-size-25">
      <!-- TOP5公司表单 -->
      <md-card :style="smallBox">
        <label :style="{'padding': '0 12px'}">
          <span :style="{'line-height': '51px', 'font-size': '16px', 'font-weight':'bold'}">{{$I18n("comp_top5")}}</span>
          <md-button @click="compTableModal" :style="{'float': 'right'}" class="md-button md-info md-simple md-theme-default">
            {{$I18n("more_info")}}
          </md-button>
        </label>
        <md-table v-model="compTableData" :style="{'margin':'0 4px'}">
          <md-table-row slot="md-table-row" slot-scope="{ item }" >
            <md-table-cell :md-label="$I18n('name')">{{ item.name }}</md-table-cell>
            <md-table-cell :md-label="$I18n('total_count')">{{ item.total }}</md-table-cell>
            <md-table-cell :md-label="$I18n('cny')">{{ item.cny }}</md-table-cell>
            <md-table-cell :md-label="$I18n('usd')">{{ item.usd }}</md-table-cell>
          </md-table-row>
        </md-table>
      </md-card>
      <!-- TOP5 APP表单 -->
      <md-card :style="smallBox">
        <label :style="{'padding': '0 12px'}">
          <span :style="{'line-height': '51px', 'font-size': '16px', 'font-weight':'bold'}">{{$I18n("app_top5")}}</span>
          <md-button @click="appTableModal" :style="{'float': 'right'}" class="md-button md-info md-simple md-theme-default">
            {{$I18n("more_info")}}
          </md-button>
        </label>
        <md-table v-model="appTableData" :style="{'margin':'0 4px'}">
          <md-table-row slot="md-table-row" slot-scope="{ item }" >
            <md-table-cell :md-label="$I18n('name')">{{ item.name }}</md-table-cell>
            <md-table-cell :md-label="$I18n('total_count')">{{ item.total }}</md-table-cell>
            <md-table-cell :md-label="$I18n('cny')">{{ item.cny }}</md-table-cell>
            <md-table-cell :md-label="$I18n('usd')">{{ item.usd }}</md-table-cell>
          </md-table-row>
        </md-table>
      </md-card>
    </div>
    <!-- 地图 -->
    <div class="md-layout-item md-size-50 " :style="{'padding':0}">
      <!-- 世界地图 -->
      <!-- <md-card :style="mapBox"> -->
        <div class="md-layout" :style="{'margin-top': '0px','height':'120px'}">
          <div class="md-layout-item md-size-33 md-layout">
            <div :style="{...titleBox, 'background-color':'#e5327050', 'border-left':'6px solid #e53270', 'padding': '12px 0 12px 12px'}">
              <span :style="{'line-height': '30px', 'font-size': '16px', 'text-align': 'left'}">{{$I18n("order_count")}}</span>
              <h1 :style="{'font-size': '30px','color':'#e53270'}">{{totalOrder.total_count}}</h1>
            </div>
          </div>
          <div class="md-layout-item md-size-33 md-layout">
            <div :style="{...titleBox, 'background-color':'#0fb6cb50', 'border-left':'6px solid #0fb6cb', 'padding': '12px 0 12px 12px'}">
              <span :style="{'line-height': '30px', 'font-size': '16px', 'text-align': 'left'}">{{$I18n("order_count")}}($)</span>
              <h1 :style="{'font-size': '30px','color':'#0fb6cb'}">{{totalOrder.usd_order_count}}[${{totalOrder.usd_order_amount}}]</h1>
            </div>
          </div>
          <div class="md-layout-item md-size-33 md-layout">
            <div :style="{...titleBox, 'background-color':'#54ad5850', 'border-left':'6px solid #54ad58', 'padding': '12px 0 12px 12px'}">
              <span :style="{'line-height': '30px', 'font-size': '16px', 'text-align': 'left'}">{{$I18n("order_count")}}(¥)</span>
              <h1 :style="{'font-size': '30px','color':'#54ad58'}">{{totalOrder.cny_order_count}}[¥{{totalOrder.cny_order_amount}}]</h1>
            </div>
          </div>
        </div>
        <div id="map" :style="mapStyle"></div>
      <!-- </md-card> -->
    </div>
    <!-- 图表(柱状图 / 饼状图) -->
    <div class="md-layout-item md-size-25 md-layout">
      <!-- 支付方式占比 (饼状图) -->
      <md-card :style="smallBox">
        <label :style="{'padding': '0 12px'}">
          <span :style="{'line-height': '51px', 'font-size': '16px', 'font-weight':'bold'}">{{$I18n("pey_type_rate")}}</span>
          <!-- <md-button :style="{'float': 'right'}" class="md-button md-info md-simple md-theme-default">{{$I18n("more_info")}}</md-button> -->
        </label>
        <div id="pie" :style="chartsBox">
          
        </div>
      </md-card>
      <!-- 公司近期数据(柱状图) -->
      <md-card :style="{...smallBox, 'margin-top': '0'}" >
        <label :style="{'padding': '0 12px'}">
          <span :style="{'line-height': '51px', 'font-size': '16px', 'font-weight':'bold'}">{{$I18n("comp_info_before")}}</span>
          <span @click="() => {dateType = 4}" class="select-charts-type" :class="{'is-seleted': dateType == 4}" >{{$I18n("all_")}}</span>
          <span @click="() => {dateType = 3}" class="select-charts-type" :class="{'is-seleted': dateType == 3}" >{{$I18n("year")}}</span>
          <span @click="() => {dateType = 2}" class="select-charts-type" :class="{'is-seleted': dateType == 2}" >{{$I18n("month")}}</span>
        </label>
        <div id="bar" :style="chartsBox"></div>
      </md-card>
    </div>
    <!-- 弹窗 -->
    <modal v-show="openModal" @close="modal_classicModalHide" class="lg-modal" :big-modal="openModalType==='import'" :type="openModalType==='delete' ?'' :'rightModal'">
      <template slot="header">
        <h4 class="modal-title">{{modalTitle}}</h4>
        <md-button class="md-simple md-just-icon md-round modal-default-button" @click="modal_classicModalHide">
          <md-icon>clear</md-icon>
        </md-button>
      </template>

      <template slot="body">
        <div  :style="{'text-align':'left'}">
          <md-table v-model="modalTableData">
            <md-table-row v-if ="openModalType=='comp'" slot="md-table-row" slot-scope="{ item }" >
              <md-table-cell :md-label="$I18n('name')">{{ item.name }}</md-table-cell>
              <md-table-cell :md-label="$I18n('total_count')">{{ item.total }}</md-table-cell>
              <md-table-cell :md-label="$I18n('cny')">{{ item.cny }}</md-table-cell>
              <md-table-cell :md-label="$I18n('usd')">{{ item.usd }}</md-table-cell>
            </md-table-row>
            <md-table-row v-else slot="md-table-row" slot-scope="{ item }" >
              <md-table-cell :md-label="$I18n('name')">{{ item.name }}</md-table-cell>
              <md-table-cell :md-label="$I18n('type')">{{ item.type }}</md-table-cell>
              <md-table-cell :md-label="$I18n('total_count')">{{ item.total }}</md-table-cell>
              <md-table-cell :md-label="$I18n('cny')">{{ item.cny }}</md-table-cell>
              <md-table-cell :md-label="$I18n('usd')">{{ item.usd }}</md-table-cell>
            </md-table-row>
          </md-table>
          <!-- 翻页 -->
          <md-card-actions v-if="total > 0" md-alignment="space-between">
            <div>
              <p class="card-category">
                {{$I18n("total" )}} : {{total}}
              </p>
            </div>
            <pagination :total="total" :per-page="pageSize" v-model="currentPage" class="pagination-no-border" type= "info"/>
          </md-card-actions>
        </div>
      </template>

      <template slot="footer">
        <md-button class="left-icon" @click="modal_classicModalHide">{{$I18n("cancel")}}</md-button>
      </template>
    </modal>
  </div>
</template>
<script>
import { Pagination } from "@/components";
import { Modal } from '@/components';
import {nMonthsAgo, copyObj, toDecimal} from "@/common/tools.js";
import * as echarts from "echarts";
// import 'echarts/map/js/world.js'
import 'echarts-maps/world.js'

class PayClass{
  constructor(total, cny_count, cny_amount, usd_count, usd_amount){
    this.total_count      = isNaN(total)      ?0 :total;
    this.cny_order_count  = isNaN(cny_count)  ?0 :cny_count;
    this.cny_order_amount = isNaN(cny_amount) ?0 :cny_amount;
    this.usd_order_count  = isNaN(usd_count)  ?0 :usd_count;
    this.usd_order_amount = isNaN(usd_amount) ?0 :usd_amount;
  }
  get usd(){
    return this.usd_order_amount
  }
  get cny(){
    return this.cny_order_amount
  }
  get usd_order(){
    return this.usd_order_count
  }
  get cny_order(){
    return this.cny_order_count
  }
  set usd(val){
    this.usd_order_amount = val
  }
  set cny(val){
    this.cny_order_amount = val
  }
  set usd_order(val){
    this.usd_order_count = val
  }
  set cny_order(val){
    this.cny_order_count = val
  }

  Add(pay){
    if(!pay){
      return this
    }
    this.total_count      = pay.total_count                + (isNaN(this.total_count)      ?0 :this.total_count);
    this.cny_order_count  = pay.cny_order_count            + (isNaN(this.cny_order_count)  ?0 :this.cny_order_count);
    this.cny_order_amount = toDecimal(pay.cny_order_amount + (isNaN(this.cny_order_amount) ?0 :this.cny_order_amount));
    this.usd_order_count  = pay.usd_order_count            + (isNaN(this.usd_order_count)  ?0 :this.usd_order_count);
    this.usd_order_amount = toDecimal(pay.usd_order_amount + (isNaN(this.usd_order_amount) ?0 :this.usd_order_amount));
    return this
  }
  AddPart(pay, zone){ // 2|cny:cny, 1|usd:usd
    if(!pay){
      return 
    }
    let count = isNaN(pay.count) ?0 :pay.count
    let fee   = isNaN(pay.fee)   ?0 :pay.fee
    if(zone === 1 || zone === "usd"){
      this.total_count      = this.total_count + count
      this.usd_order_count  = this.usd_order_count + count
      this.usd_order_amount = toDecimal(this.usd_order_amount + fee)
    }else if(zone === 2 || zone === "cny"){
      this.total_count      = this.total_count + count
      this.cny_order_count  = this.cny_order_count + count
      this.cny_order_amount = toDecimal(this.cny_order_amount + fee)
    }
  }
  Copy(){
    return new PayClass().Add(this)
  }
}
export default {
  components: {
    Pagination,
    Modal,
  },
  data() {
    let today = nMonthsAgo(0);
    return {
      selectedCountry : "__TOTAL__",
      dateType : 2,
      today    : today,
      todayMonth : today.split("-")[0] + "-" + today.split("-")[1],
      //
      smallBox:{
        height:'1px',
        width : '100%',
        'margin-bottom' : '40px',
        'margin-top' : '0px',
      },
      mapBox:{
        height:'1px',
        width : '100%',
        // 'margin-top': 0,
      },
      titleBox :{
        height : '120px',
        width : "100%",
        'background-color': '#99999950',
      },
      mapStyle:{
        height:'1px',
        width : '100%',
        'margin-top': 0,
      },
      chartsBox: {
        height: '10px',
        width : '100%',
        'margin-bottom' : '40px',
      },
      // 表格相关
      icon  : "assignment",
      title : this.$I18n("product"),

      // 是否打开弹窗
      openModal: false,
      openModalType : "add", // "delete" | "edit" | "sub-add" | "sub-edit" | "sub-delete"
      // 弹窗相关
      modalTitle : "",
      modalData : [],
      chartsColor: {
        bar :{
          colors : ["#12b8cc","#5db461","#9c27b0","#e53371","#fe9f1b"] // 至少要5个
        },
        map :{
          // ,"rgb(9,98,191)","rgb(5,64,122)"
          // mapColor : ["rgb(109,177,242)","rgb(89,156,226)","rgb(27,138,230)"],
          // mapColor: [ "#1468AD","rgb(27,138,230)" ,"rgb(89,156,226)","rgb(109,177,242)" ],
          mapColor : [ "#000000", "#444444", "#666666", "#888888", "#aaaaaa"],
          areaColor : "#dddddd", //"rgba(0,0,0,1)",//"rgb(9,98,191)",
          emphasis:{
            labelColor: "#ffffff",
            areaColor: "#eeeeee"
          },
          select : ""
        },
        pie: {
          color: ["#12b8cc","#5db461","#9c27b0","#e53371","#fe9f1b","rgb(171 171 171)"] //只用3个
        }
      },
      compObj        : {},
      appDataRela    : {},
      compDataRela   : {},
      compTableData  : {},
      appTableData   : {},
      chartsData     : {},
      mapCharts      : {},
      pieCharts      : {},
      barCharts      : {},
      compLayerData  : {},
      appLayerData   : {},
      hoverBarTooltip: "",

      totalOrder : new PayClass(),
        // 分页相关
        pageSize : 10,
        currentPage : 1,
        total : 0,
    };
  },
  methods:{
    simpleJSON () {
      return new PayClass()
    },
    simplePayJSON () {
      let res = {};
      this.$Param.payment.forEach(item => {
        res[item.id] = new PayClass()
      })
      return  res
    },
    compTableModal () {
      this.openModalType = "comp"
      this.modalData = [...this.sortArray(this.compLayerData.map(item => {
        return {
          id:item.id,
          name: item.name,
          total: item.data.total_count,
          cny: Math.round(item.data.cny_order_amount),
          usd: Math.round(item.data.usd_order_amount),
        }
      }))];
      this.currentPage = 1;
      this.total = this.modalData.length;
      this.modalTitle = this.$I18n("comp_detail")
      this.openModal = true;
    },
    appTableModal () {
      this.openModalType = "app"
      let clientType = {
        1 :this.$I18n("web"),
        2 :this.$I18n("android"),
        3 :this.$I18n("ios"),
        4 :this.$I18n("mac"),
        5 :this.$I18n("ipad"),
        6 :this.$I18n("pc"),
      }           
      this.modalData = [...this.sortArray(this.appLayerData
        .filter(item => {
          return !!item.data.__TOTAL__.total_count
        })
        .map(item => {
          return {
            name: item.name,
            type: clientType[this.appDataRela[item.id].client_type],
            total: item.data.__TOTAL__.total_count,
            cny: Math.round(item.data.__TOTAL__.cny_order_amount),
            usd: Math.round(item.data.__TOTAL__.usd_order_amount),
          }
        })
      )]
      this.modalTitle = this.$I18n("app_detail")
      this.currentPage = 1;
      this.total = this.modalData.length
      this.openModal = true;
    },
    modal_classicModalHide () {
      this.openModal = false;
    },
    api_getApp (){
      return this.$api.getAppDetailId({})
        .then(this.$Then(res => {
          res.data.forEach((item) => {
            this.compDataRela[item.comp_id] = {
              comp_id   : item.comp_id,
              comp_name : item.comp_name,
            }
            this.appDataRela[item.app_id] = {
              client_type : item.client_type,
              app_name    : item.name,
              comp_id     : item.comp_id,
              comp_name   : item.comp_name,
            }
            if (!this.compObj[item.comp_id]) {
              this.compObj[item.comp_id] = {
                __TOTAL__: this.simpleJSON(),
                __PAY__: this.simplePayJSON(),
              }
            }
            this.compObj[item.comp_id][item.app_id] = {
              __TOTAL__: this.simpleJSON(),
              ...this.simplePayJSON(),
            }
          })
        }))
        .catch(this.$Catch(this.$I18n("unknown_error")))
    },
    getHeight(){
      this.smallBox.height = (window.innerHeight-140) / 2 -41 +'px';
      this.mapBox.height   = (window.innerHeight-184) + 2 +'px';
      this.mapStyle.height = (window.innerHeight-302) + 'px';
      this.chartsBox.height= (window.innerHeight-140) / 2 -92 +'px';
      if(this.mapCharts.resize){
        this.mapCharts.resize();
        this.pieCharts.resize();
        this.barCharts.resize();
      }
    },
    sortArray (array){
      for(var i = 0 ; i< array.length; i++){
        for(var j = i; j <array.length; j ++){
          var I = array[i]
          var J = array[j]
          if(J.total>I.total){
            array[i] = J
            array[j] = I
          }
        }
      }
      return array
    },
    chartOption (type){
      switch (type) {
        // 竖着的柱状图 [需要 title.text, legend.data, xAxis.data, series]
        case "vertical_bar":
          return {
            tooltip: {
              // formatter: function(params){
              //  return params[0].name.replace(/\n/g,"") + "<p>CN :1000</p><p>EN :2000</p>"
              // },
              trigger: 'axis',
              textStyle:{
                align:"left"
              },
              axisPointer: {            // 坐标轴指示器，坐标轴触发有效
                type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
              }
            },
            title: {
              text: '',//
            },
            legend: {
              data: [], //
              top:'40px',
              left:'0',
            },
            grid: {
              left: '3%',
              right: '4%',
              bottom: '3%',
              top:'32px',
              containLabel: true
            },
            xAxis: {
              type: 'category',
              data: [], //
              axisLabel:{
                interval:0
              } ,
              
              axisLine:{
                lineStyle:{
                  // color:"#ffffff"
                }    // x轴坐标轴颜色
              },
            },
            yAxis: {
              type: 'value',
              axisLine:{
                lineStyle:{
                  // color:"#ffffff"
                }    // x轴坐标轴颜色
              },
            },
            series: []
          };
        case "pie":
          return  {
            title:{
              text:""
            },
            tooltip: {
              trigger: 'item',
              formatter: '{a} <br/>{b}: {c} ({d}%)'
            },
            legend: {
              top: "32px",
              data: []//['直达', '营销广告', '搜索引擎', '邮件营销', '联盟广告', '视频广告', '百度', '谷歌', '必应', '其他']
            },
            series: [
              {
                name: '总额',
                type: 'pie',
                selectedMode: 'single',
                radius: ['20%', '80%'],

                label: {
                  // position: 'inner'
                  bleedMargin: 0,
                  position: 'inside',
                  formatter:() => {
                    return ''
                  },
                },
                labelLine: {
                  show: false
                },
                color: this.chartsColor.pie.color,
                data: []
              },
            ]
          };
      }
    },
    getOrderData : function(){
      var sendData ={}
      if (this.dateType == 2) {
        this.todayMonth = this.today.split("-")[0] + "-" + this.today.split("-")[1]
        sendData = { 
          comp_id   : Object.keys(this.compDataRela),
          app_id    : Object.keys(this.appDataRela),
          type      : 2,
          start_date: nMonthsAgo(3),
          end_date  : nMonthsAgo(0),
        }
      } else if (this.dateType == 3) {
        this.todayMonth = this.today.split("-")[0] + "-01"
        sendData = { 
          comp_id    : Object.keys(this.compDataRela),
          app_id     : Object.keys(this.appDataRela),
          type       : 3,
          start_date : nMonthsAgo(36),
          end_date   : nMonthsAgo(0),
        }
      } else if (this.dateType == 4) {
        this.todayMonth = this.today.split("-")[0] + "-" + this.today.split("-")[1]
        sendData = { 
          comp_id    : Object.keys(this.compDataRela),
          app_id     : Object.keys(this.appDataRela),
          type       : 4,
          start_date : nMonthsAgo(3),
          end_date   : nMonthsAgo(0),
        }
      } else {
        return new Promise(() => {
          setTimeout(()=>{},0)
        })
      }
      return this.$api.getOrderaCompStatistical(sendData)
        .then(this.$Then(res_comp_order => {
          this.chartsData = {}
          res_comp_order.data.forEach((item)=>{
            var detail = JSON.parse(item.zone_detail)
            var date = item.start_date.split("-")[0] + "-" + item.start_date.split("-")[1]
            if (this.dateType == 4) {
              date = nMonthsAgo(0).split("-")[0] + "-" + nMonthsAgo(0).split("-")[1]
            }
            if(!this.chartsData[date]){
              this.chartsData[date] = {
                __TOTAL__ : copyObj(this.compObj),
                __PAY__   : this.simplePayJSON(),
              }
            }

            for(var zoneKey in detail){
              var zoneI18n = ""
              if (zoneKey == "HK" || zoneKey == "TW" || zoneKey == "MO"){
                zoneI18n = this.$En("CN")
              } else if (zoneKey == "") {
                zoneI18n = this.$I18n("unknown_zone")
              } else {
                zoneI18n = this.$En(zoneKey)
              }
              if(!this.chartsData[date][zoneI18n]) {
                this.chartsData[date][zoneI18n] = {
                  __TOTAL__ : this.simpleJSON(),
                  __PAY__   : this.simplePayJSON(),
                }
              }
              if(!this.chartsData[date][zoneI18n][item.id]){
                this.chartsData[date][zoneI18n][item.id] = copyObj(this.compObj[item.id])
              }
              var datePay       = this.chartsData[date].__PAY__
              var zonePay       = this.chartsData[date][zoneI18n].__PAY__
              var zoneTotal     = this.chartsData[date][zoneI18n].__TOTAL__
              var compTotal     = this.chartsData[date][zoneI18n][item.id].__TOTAL__
              var datecompTotal = this.chartsData[date].__TOTAL__[item.id].__TOTAL__

              for(var payKey in detail[zoneKey]){
                if(detail[zoneKey][payKey][2]){

                  zonePay[payKey].AddPart(detail[zoneKey][payKey][2], 2)
                  datePay[payKey].AddPart(detail[zoneKey][payKey][2], 2)
                  zoneTotal.AddPart(detail[zoneKey][payKey][2], 2)
                  compTotal.AddPart(detail[zoneKey][payKey][2], 2)
                  datecompTotal.AddPart(detail[zoneKey][payKey][2], 2)
                }
                if(detail[zoneKey][payKey][1]){
                  zonePay[payKey].AddPart(detail[zoneKey][payKey][1], 1)
                  datePay[payKey].AddPart(detail[zoneKey][payKey][1], 1)
                  zoneTotal.AddPart(detail[zoneKey][payKey][1], 1)
                  compTotal.AddPart(detail[zoneKey][payKey][1], 1)
                  datecompTotal.AddPart(detail[zoneKey][payKey][1], 1)
                }
              }
            }
          })
          return this.$api.getOrderStatistical(sendData)
            .then((res_order) => {
              res_order.data.forEach((item) =>{
                var detail = JSON.parse(item.zone_detail)
                var date = item.start_date.split("-")[0] + "-" + item.start_date.split("-")[1]
                if (this.dateType == 4) {
                  date = nMonthsAgo(0).split("-")[0] + "-" + nMonthsAgo(0).split("-")[1]
                }
                for(var zoneKey in detail){
                  let zoneI18n = this.$En(zoneKey)
                  if (zoneKey == "HK" || zoneKey == "TW" || zoneKey == "MO"){
                    zoneI18n = this.$En("CN")
                  } else if (zoneKey == "") {
                    zoneI18n = this.$En("unknown_zone")
                  }
                  if(!this.chartsData[date]){
                    continue;
                  }
                  if(!this.chartsData[date][zoneI18n]) {
                    this.chartsData[date][zoneI18n] = {
                      __TOTAL__: this.simpleJSON(),
                      __PAY__  : this.simplePayJSON(),
                    }
                  }
                  let comp_id = this.appDataRela[item.id].comp_id;
                  if(!this.chartsData[date][zoneI18n][comp_id]){
                    this.chartsData[date][zoneI18n][comp_id] = copyObj(this.compObj[comp_id])
                  }
                  var dateappTotal = this.chartsData[date].__TOTAL__[comp_id][item.id].__TOTAL__
                  var appTotal     = this.chartsData[date][zoneI18n][comp_id][item.id].__TOTAL__
                  for(let payKey in detail[zoneKey]){
                    var info       = this.chartsData[date][zoneI18n][comp_id][item.id][payKey];
                    if(detail[zoneKey][payKey][2]){
                      appTotal.AddPart(detail[zoneKey][payKey][2], 2)
                      dateappTotal.AddPart(detail[zoneKey][payKey][2], 2)
                      info.AddPart(detail[zoneKey][payKey][2], 2)
                    }
                    if(detail[zoneKey][payKey][1]){
                      appTotal.AddPart(detail[zoneKey][payKey][1], 1)
                      dateappTotal.AddPart(detail[zoneKey][payKey][1], 1)
                      info.AddPart(detail[zoneKey][payKey][1], 1)
                    }
                    this.chartsData[date][zoneI18n][comp_id][item.id][payKey] = info
                  }
                }
              })
              this.buildMap();
            })
        }))
        .catch(this.$Catch(this.$I18n("unknown_error")))
    },
    buildMap(){
      var thisMonData = this.chartsData[this.todayMonth]
      thisMonData  = thisMonData ? thisMonData : {}
      var maxValue = 0 // 地图(MAP) 图表的的最大值 option.visualMap.max
      var mapData  = [] // option.series.data
      this.selectedCountry = "__TOTAL__"  // 其他4个小表的显示类型 (__ALL__为全部国家统计)
      Object.keys(thisMonData).forEach(function(item){
        // <--MAP 数据部分-->
        if(item != "__TOTAL__" && item != "__PAY__"){
          var total = thisMonData[item].__TOTAL__
          var totalOrder = total.total_count
          mapData.push({
            name : item,
            value: totalOrder,
          })
          if(totalOrder>maxValue){
            maxValue = totalOrder
          }
        }
      })
      var mapOption = { 
          tooltip: {  
            trigger: 'item',  
            textStyle:{
              align:"left"
            },
            formatter: (params) => {
              if(isNaN(params.value) || params.value==0){
                // return params.seriesName + '<br/>' + params.name + ' : ' + 0;
                return this.$I18n(params.name)
              }
              var paramsFullData = thisMonData[params.name].__TOTAL__
              // [国家名]: [总订单数] (￥[交易金额]([订单数])$[交易金额]([订单数]))
              return params.seriesName + '<br/>' + 
                this.$I18n(params.name) + ' : ' + params.value + '<br/>' + 
                "￥"+ paramsFullData.cny_order_amount + "("+ paramsFullData.cny_order_count +")" + "<br/>" +
                "$ "+ paramsFullData.usd_order_amount + "("+ paramsFullData.usd_order_count +")" + "<br/>"
            },
          },
          geo:{
            regions:[],
          },
          visualMap: {  
            min: 0,  
            max: maxValue+1/*取最高的*/,  
            text:['High','Low'],  
            realtime: false,  
            calculable: true,  
            // color: ["#2962ff", "#2979ff", "#82b1ff","#1565c0","#1e88e5","#42a5f5","#90caf9"]  ,
            // color: ["rgb(39,99, 245)", "rgb(14,16,32)"],
            color: this.chartsColor.map.mapColor,
            hoverLink :false,
            show:false,
          },  
          series: [  
            {  
              name: '订单数据',  
              type: 'map',  
              map: 'world',  
              // roam: true,  
              // left: 0, top: 50, right: 0, bottom: 70,
              layoutCenter: ['50%', '40%'],
              layoutSize: '120%',
              itemStyle:{
                areaColor: this.chartsColor.map.areaColor,//'#01215c',
                borderWidth: 1,//设置外层边框
                borderColor:'#eeeeee',
                // shadowColor: 'rgba(0,54,255, 1)',
                // shadowBlur: 5,
                // areaColor: this.chartsColor.map.areaColor
              },
              emphasis: {
                label:{
                  color: this.chartsColor.map.emphasis.labelColor,
                  formatter:function(){return ""}
                },
                itemStyle: {
                  areaColor: this.chartsColor.map.emphasis.areaColor
                }
              },
              select : {
                itemStyle: {
                  // areaColor: this.chartsColor.map.emphasis.areaColor,
                  areaColor: "#12b8cc",
                },
                label :{
                  // formatter : (params) => {
                  //   return this.$I18n(params.name)
                  // },
                  formatter : "",
                },
              },
              data: mapData,
            }  
          ]  
      };
      this.mapCharts.setOption(mapOption);
      this.buildSub(this.selectedCountry)
    },
    buildSub() {
      this.todayCharts = this.chartsData[this.todayMonth] ? this.chartsData[this.todayMonth] : {
        __TOTAL__: this.simpleJSON(),
        __PAY__: this.simplePayJSON(),
      }
      var subData       = this.chartsData[this.todayMonth] ? this.chartsData[this.todayMonth][this.selectedCountry] : {}
      var compArray     = []; // 公司数组(COMP 表格)
      var appArray      = []; // APP数组(APP 表格)
      var payType       = {}; // 支付方式参数(饼图)
      var compDateArray = {}; // 每日每个公司的数据(柱状图)
      if(this.selectedCountry == "__TOTAL__"){
        for(var key in subData) {
          this.totalOrder.Add(subData[key].__TOTAL__)
        }
      } else {
        this.totalOrder = subData.__TOTAL__.Copy()
      }
      for(var compId in subData){
        if (compId != "__TOTAL__" && compId != "__PAY__"){ 
          for(var appId in subData[compId]){
            if (appId != "__TOTAL__" && appId != "__PAY__"){
              appArray.push({
                id  : appId,
                name: this.appDataRela[appId].app_name,
                comp: this.appDataRela[appId].comp_name,
                data: copyObj(subData[compId][appId])
              })
            } else if (appId == "__TOTAL__") { // 处理 compArray & appArray// 处理 payType & compDateArray
              compArray.push({
                id  : compId,
                name: this.compDataRela[compId].comp_name,
                data: copyObj(subData[compId].__TOTAL__)
              })
            }
          }
        } 
      }
      this.compLayerData = copyObj(compArray)
      this.appLayerData  = copyObj(appArray)
      if(this.selectedCountry == "__TOTAL__"){
        payType = copyObj(this.todayCharts.__PAY__)
      } else {
        payType = subData ? copyObj(subData.__PAY__) : this.simplePayJSON()
      }
      this.$Param.payment.forEach(item => {
        if(!payType[item.id]){
          payType[item.id] = this.simpleJSON()
        }
      })
      for(let key in this.chartsData){
        compDateArray[key] = new PayClass()
        if (this.selectedCountry == "__TOTAL__") {
          for(let payKey in this.chartsData[key].__PAY__) {
            compDateArray[key].Add(this.chartsData[key].__PAY__[payKey])
          }
        } else {
          if(!this.chartsData[key][this.selectedCountry]){
            this.chartsData[key][this.selectedCountry] = {
              __TOTAL__: this.simpleJSON(),
              __PAY__: this.simplePayJSON(),
            }
          }
          compDateArray[key].Add(this.chartsData[key][this.selectedCountry].__TOTAL__)
        }
      }
      /// 表格处理
      var tableCompData = [];
      var tableAppData  = [];
      var compID        = [];
      var compName      = [];
      compArray.forEach(function(item){
        if(item.data.total_count == 0){
          return
        }
        tableCompData.push({
          id:item.id,
          name: item.name,
          total: item.data.total_count,
          cny: Math.round(item.data.cny_order_amount),
          usd: Math.round(item.data.usd_order_amount),
        })
      })
      appArray.forEach(function(item){
        if(item.data.__TOTAL__.total_count == 0){
          return
        }
        tableAppData.push({
          name: item.name,
          total: item.data.__TOTAL__.total_count,
          cny: Math.round(item.data.__TOTAL__.cny_order_amount),
          usd: Math.round(item.data.__TOTAL__.usd_order_amount),
        })
      })
      tableCompData = this.sortArray(tableCompData).splice(0,5)
      tableCompData.forEach(function(item){
        compID.push(item.id)
        compName.push(item.name)
      })
      tableAppData = this.sortArray(tableAppData).splice(0,5)

      var payPieOption = this.chartOption("pie")
      let all = 0
      for(let ptype in payType){
        if(!isNaN(payType[ptype].total_count)){
          all = all + parseInt(payType[ptype].total_count)
        }
      }
      payPieOption.series[0].data = [
        {
          name:  this.$I18n("free"),
          value: payType[0].total_count ,
          _total: all,
        }, {
          name:  this.$I18n("alipay"),
          value: payType[1].total_count,
          _total: all,
        }, {
          name:  this.$I18n("wechart"),
          value: payType[2].total_count,
          _total: all,
        }, {
          name:  this.$I18n("paypal"),
          value: payType[3].total_count,
          _total: all,
        }, {
          name:  "PayU",
          value: payType[6].total_count,
          _total: all,
        }, {
          name:  this.$I18n("stripe"),
          value: payType[7].total_count,
          _total: all,
        }, {
          name:  this.$I18n("paytm"),
          value: payType[8].total_count,
          _total: all,
        }, {
          name:  this.$I18n("comp_pay"),
          value: payType[4].total_count ,
          _total: all,
        }, {
          name:  this.$I18n("cdk"),
          value: payType[5].total_count ,
          _total: all,
        }, 
      ];
      payPieOption.series[0].label.formatter = function(param){
        if(param.value == 0 || param.value / param.data._total < 0.3){
          return ""
        }
        return param.name
        // + ":" + param.value + "(" + param.percent + "%)"
      };
      payPieOption.tooltip = {
          trigger: 'item',
            textStyle:{
              align:"left"
            },
          formatter:function(params){
            var paramsFullData = payType[params.dataIndex];
                  return params.name + ' : ' + params.value + '<br/>' + 
                    "￥"+ (paramsFullData.cny_order_amount) + "("+ paramsFullData.cny_order_count +")" + "<br/>" +
                    "$ "+ (paramsFullData.usd_order_amount) + "("+ paramsFullData.usd_order_count +")" + "<br/>"
          }
      }
      var compBarOption = this.chartOption("vertical_bar") // legend.data, yAxis.data, series
      compBarOption.tooltip = {
          trigger: 'axis',
          axisPointer: {
              type: 'shadow'
          },
          textStyle:{
            align:"left"
          },
          formatter:(params) =>{
            this.hoverBarTooltip = params[0].data.name 
            var result = params[0].data.name + "<br/>"
            for(var i=0;i<params.length && i < 1; i++){
              var item = params[i]
              result  = result +// item.seriesName + "[" + item.value + "] : "+ 
                "¥"+   (item.data.other.cny_order_amount) +"[" + item.data.other.cny_order_count + 
                "]<br/>$"+ (item.data.other.usd_order_amount) +"[" + item.data.other.usd_order_count +  
                "]<br/>"

            }
            return result
          }
      }
      compBarOption.xAxis.data = []
      compBarOption.series = []
      var moneyTypeArray= ["usd", "cny"]
      for(var i=0;i<moneyTypeArray.length; i++){
        var data = []
        if (this.dateType == 4) {
          let month = nMonthsAgo(0).split("-")[0] + "-" + nMonthsAgo(0).split("-")[1]
          if (!compDateArray[month]){
            compDateArray[month] = new PayClass(0,0,0,0,0)
          }
          data.push({
            name: "全部",
            value: compDateArray[month]?compDateArray[month][moneyTypeArray[i]] :0,
            other: compDateArray[month],
          })
          if(i==0){
            compBarOption.xAxis.data.push("全部")
          }
        } else {
          for(var j=2; j>=0; j--){
            let month = nMonthsAgo(j).split("-")[0] + "-" + nMonthsAgo(j).split("-")[1]
            if (this.dateType == 3) { 
              month = nMonthsAgo(j * 12).split("-")[0] + "-01"
            }
            if (!compDateArray[month]){
              compDateArray[month] = new PayClass(0,0,0,0,0)
            }
            data.push({
              name: this.dateType ==3 ?nMonthsAgo(j * 12).split("-")[0] :month,
              value: compDateArray[month]?compDateArray[month][moneyTypeArray[i]] :0,
              other: compDateArray[month]
            })
            if(i==0){
              compBarOption.xAxis.data.push(this.dateType ==3 ?nMonthsAgo(j * 12).split("-")[0] :month)
            }
          }
        }
        compBarOption.series.push({
          name: compName[i],
          type: "bar",
          stack: compName[i],
          barMaxWidth:"32px",
          color: this.chartsColor.bar.colors[i],
          label:{
            show:true,
            // position:"insideRight",
            position:"top"
          },
          data: data
        })
      }
      this.pieCharts.clear()
      this.barCharts.clear()
      this.pieCharts.setOption(payPieOption)
      this.barCharts.setOption(compBarOption)
      return
    }
  },
  created(){
    window.addEventListener('resize', this.getHeight);
  },
  mounted : function() {
    // 地图图表
    this.getHeight()
    this.api_getApp()
      .then(() => {
        this.mapCharts = echarts.init(document.getElementById('map'));
        this.pieCharts = echarts.init(document.getElementById('pie'));
        this.barCharts = echarts.init(document.getElementById('bar'));
        return this.getOrderData()
      })
      .then(() => {
        this.mapCharts.resize();
        this.pieCharts.resize();
        this.barCharts.resize();
        this.mapCharts.on('click',  (params) => {
          // 支付方式 图表 (饼状图)
          if(!this.chartsData[this.todayMonth][params.name]){
            return
          }
          if(this.selectedCountry == params.name){
            this.selectedCountry ="__TOTAL__"
          } else {
            this.selectedCountry = params.name 
          }
            this.buildSub(this.selectedCountry);
        });
        this.barCharts.getZr().on('click', () => {
            this.todayMonth = this.hoverBarTooltip
            if (this.dateType == 3) {
              this.todayMonth = this.todayMonth + "-01"
            }  else if(this.dateType == 4) {
              return
            }
          this.buildMap()
        });
      })
  },
  watch: {
    compLayerData (to) {
      this.compTableData = [...this.sortArray(to.map(item => {
        return {
          id:item.id,
          name: item.name,
          total: item.data.total_count,
          cny: Math.round(item.data.cny_order_amount),
          usd: Math.round(item.data.usd_order_amount),
        }
      }))].splice(0,5)
    },
    appLayerData (to) {
      this.appTableData = [...this.sortArray(to
        .filter(item => {
          return !!item.data.__TOTAL__.total_count
        })
        .map(item => {
          return {
            name: item.name,
            total: item.data.__TOTAL__.total_count,
            cny: Math.round(item.data.__TOTAL__.cny_order_amount),
            usd: Math.round(item.data.__TOTAL__.usd_order_amount),
          }
        })
      )].splice(0,5)
    },
    dateType (){
      this.getOrderData();
    },
  },
  computed: {
    modalTableData (){
      return [...this.modalData].splice((this.currentPage-1) * this.pageSize, this.pageSize)
    },
  },
}
</script>
<style lang="scss" scoped>
  .select-charts-type {
    float: right;
    margin:0px;
    line-height:51px;
    padding:0 8px;
    cursor:pointer;
  }
  .select-charts-type.is-seleted {
    color:#00bcd4;
  }
      
        
  .left-transfer-item{
    margin-right : 24px;
  }
  .left-transfer-item,
  .right-transfer-item{
    text-align: left;
    display: inline-block;
  }
  .md-form-label-out{
    padding-left:  15px !important;
    padding-rigth: 15px !important;
  }
  .md-subhead {
    text-align:left;
    margin-left: 80px;
  }
  .not-bind{
    font-weight:200 !important;
  }
  .md-card-only-title{
    margin: 0;
    box-shadow: none !important;
    text-align: left;
    position: relative;
    top: -12px;
    left: -20px;
  }
  .md-card-only-title .title{
    text-align:left !important;
  }
  .md-layout {
    overflow: hidden;
  }
  .md-layout-item.md-size-0.md-size-60,
  .md-layout-item.md-size-0.md-size-66,
  .md-layout-item.md-size-0.md-size-50{
    right: 0;
  }
  .md-layout-item.md-size-0{
    position: relative;
    right: -10000px;
    transition: all 1s;
  }
  .md-layout-item {
    transition: all .5s;
  }
  // 弹窗内组件

  //表格里的多选框
    .checkbox-color{
      color: #9c27b0  !important;
    }
    .table-checkbox {
      width: 80px;
    }
    .table-checkbox  .md-checkbox{
      margin: 0;
    }
    .table-selected{
      text-align: left;
      width: 100%;
    }

  // 表单里的单选框
  .radio-layout{
    margin-top: 6px;
  }
  // 弹窗的表单
  .md-form-label{
    color: #aaa;
    font-weight: 400;
    margin-bottom: 0;
    font-size: 16px;
    line-height: 1.5;
    padding-top: 20px ;
    padding-bottom: 20px ;
    text-align: left ;
  }
  .md-layout-left{
    text-align: left;
  }
  // 弹窗
  .lg-modal .modal-container{
    width : 80%;
    max-width: unset;
  }
  // 表格的ID列
  .numbers {
    width: 60px;
  }
  // 表格的按钮列
  .button-box {
    width: 120px;
  }
  //左侧iocn
  .left-icon {
    margin-right: 20px;
  }
  // flaot 右的按钮
  .right-button {
    float:right;
  }

  .text-right .md-table-cell-container {
    display: flex;
    justify-content: flex-end;
  }
  .md-table .md-table-head:last-child {
    text-align: right;
  }

  .table-stats {
    display: flex;
    align-items: center;
    text-align: right;
    flex-flow: row wrap;

    .td-price .td-total {
      display: inline-flex;
      font-weight: 500;
      font-size: 1.0625rem;
      margin-right: 50px;
    }

    &.table-striped .td-price {
      border-bottom: 0;
    }

    .td-price {
      font-size: 26px;
      border-top: 1px solid #ddd;
      border-bottom: 1px solid #ddd;
    }

    .td-price,
    > div {
      flex: 0 0 100%;
      padding: 12px 8px;
    }
  }
</style>